import { Transaction, Withdrawals, Reserve } from "@/components/Icon"

export type TransactionData = {
  name: string
  titleKey: string
  descriptionKey: string
  IconComponent: React.FC
  iconTitleKey: string
  isShowCTA?: boolean
}[]

export const transactionData = [
  {
    name: "transaction",
    titleKey: "section_two.contents_2_title",
    descriptionKey: "section_two.contents_2_paragraph",
    IconComponent: Transaction as React.FC,
    iconTitleKey: "section_two.transaction",
  },
  {
    name: "withdrawals",
    titleKey: "section_two.contents_3_title",
    descriptionKey: "section_two.contents_3_paragraph",
    IconComponent: Withdrawals as React.FC,
    iconTitleKey: "section_two.withdrawals",
  },
  {
    name: "1:1 reserve",
    titleKey: "section_two.contents_4_title",
    descriptionKey: "section_two.contents_4_paragraph",
    IconComponent: Reserve as React.FC,
    iconTitleKey: "section_two.reserve",
    isShowCTA: true,
  },
]
